import styles from "./Library.module.css";
import { SearchAndFilters } from "./SearchAndFilters";
import { Tabs } from "./Tabs";
import { useActiveTab } from "./useActiveTab";

export function Toolbar() {
  const { activeTab } = useActiveTab();

  return (
    <div className={styles.toolbar}>
      <Tabs />

      <div className={styles.rightSide}>
        <SearchAndFilters activeTab={activeTab} />
      </div>
    </div>
  );
}
